<template>
  <footer>
    <div class="rrss">
      <span><a href="#">Facebook</a></span>
      <span><a href="#">Twitter</a></span>
      <span><a href="#">Dribbble</a></span>
      <span><a href="#">Instagram</a></span>
    </div>

    <div>
      <span>@2020. by <a href="clujan.eu"> Carlos Luján</a></span>
      <span class="separate">|</span>
      <span><a href="#">Privacy Policy</a></span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped lang="scss">
footer {
  position: relative;
  padding: 50px 0;
  display: flex;
  justify-content: space-between;
}

.rrss span {
  margin-right: 20px;
}

span,
a {
  color: #7c7c83;
  text-decoration: none;
  font-size: 14px;
  color: #7c7c83;
  transition: 0.3s;
}

a:hover {
  color: #fff;
  transition: 0.3s;
}

.separate {
  margin: 0 15px;
}
</style>
